import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
    Button,
    Card,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    InputAdornment,
    TextField
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import React, {
    useEffect,
    useRef,
    useState
} from "react";
import { connect } from "react-redux";
import { changePassword, changePasswordErrorClear } from "store/app/authentication/change-password/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { Required } from "ui-component/custom-components/mandatory";

const ChangePassword = (props) => {

    const { open, email, errorMessage, onClose, isPending } = props;

    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [changePasswordData, setChangePasswordData] = useState();
    const [errors, setErrors] = useState({});
    // const [disableButton, setDisableButton] = useState(false);

    const oldPasswordInputRef = useRef(null);
    const newPasswordInputRef = useRef(null);
    const confirmPasswordInputRef = useRef(null);

    useEffect(() => {
        setChangePasswordData({
            // ...changePasswordData,
            emailId: email,
        })
        setErrors({});
        props.changePasswordErrorClear();
    }, [open])

    const handleKeyDownNew = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            newPasswordInputRef.current.focus();
        }
    }

    const handleKeyDownConfirm = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            confirmPasswordInputRef.current.focus();
        }
    };

    const validateOnchange = (e) => {

        const { name, value } = e.target;
        let currentError = { ...errors };
        if (name === 'oldPassword') {
            if (changePasswordData['newPassword']?.trim() === value?.trim()) {
                currentError['newPassword'] = 'New password should not match the old password';
            }
            else {
                delete currentError.oldPassword;
                if (changePasswordData['newPassword']) {
                    delete currentError.newPassword;
                }
            }
        }
        else if (name === 'newPassword') {
            if (changePasswordData['oldPassword']?.trim() === value?.trim()) {
                currentError['newPassword'] = 'New password should not match the old password';
            }
            else {
                delete currentError.newPassword;
            }
            if (changePasswordData['confirmPassword']) {
                if (changePasswordData['confirmPassword']?.trim() !== value?.trim()) {
                    currentError['confirmPassword'] = 'Confirm password should match the new password';
                }
                else if (changePasswordData['confirmPassword']?.trim() === value?.trim()) {
                    delete currentError.newPassword;
                    delete currentError.confirmPassword;
                }
                else {
                    delete currentError.newPassword;
                }
            }
        }
        else if (name === 'confirmPassword') {
            if (changePasswordData['newPassword']?.trim() !== value?.trim()) {
                currentError['confirmPassword'] = 'Confirm password should match the new password';
            }
            else {
                delete currentError.confirmPassword;
            }
        }

        setChangePasswordData({
            ...changePasswordData,
            [name]: value
        })
        setErrors({
            ...currentError,
        })
    }

    const handleChangePassword = (e) => {
        e.preventDefault();

        const { oldPassword, newPassword, confirmPassword } = changePasswordData || {};
        const currentErrors = {};

        if (!oldPassword && !oldPassword?.trim()) {
            currentErrors.oldPassword = 'Old password is required';
        }
        if (!newPassword && !newPassword?.trim()) {
            currentErrors.newPassword = 'New password is required';
        }
        if (errors?.newPassword) {
            currentErrors.newPassword = 'New password should not match the old password';
        }
        if (!confirmPassword && !confirmPassword?.trim()) {
            currentErrors.confirmPassword = 'Confirm password is required';
        }
        if (errors?.confirmPassword) {
            currentErrors.confirmPassword = 'Confirm password should match the new password';
        }
        setErrors(currentErrors);

        if (Object.keys(currentErrors).length === 0) {
            props.changePassword(changePasswordData);
        }
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog open={open} maxWidth={'xs'} fullWidth onClose={validateClose}>
                {open && (
                    <>
                        <Card>
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>Change Password
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <DialogContent>
                                {errorMessage && <ErrorAlert content={errorMessage} />}
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={3} justifyContent={'center'}>
                                            <Grid item md={12}>
                                                <TextField
                                                    autoFocus
                                                    inputRef={oldPasswordInputRef}
                                                    fullWidth
                                                    size="small"
                                                    name='oldPassword'
                                                    type={!showOldPassword ? 'password' : 'text'}
                                                    label={<div >Old Password <Required /></div>}
                                                    onChange={validateOnchange}
                                                    onKeyDown={handleKeyDownNew}
                                                    error={errors?.oldPassword}
                                                    helperText={errors?.oldPassword}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end">
                                                            <IconButton
                                                                size="small"
                                                                aria-label={showOldPassword ? 'hide the password' : 'display the password'}
                                                                onClick={() => setShowOldPassword(!showOldPassword)}
                                                                edge="end"
                                                            >
                                                                {showOldPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item md={12}>
                                                <TextField
                                                    inputRef={newPasswordInputRef}
                                                    label={<>New Password <Required /></>}
                                                    fullWidth
                                                    size="small"
                                                    name='newPassword'
                                                    type={!showNewPassword ? 'password' : 'text'}
                                                    onChange={validateOnchange}
                                                    onKeyDown={handleKeyDownConfirm}
                                                    error={errors?.newPassword}
                                                    helperText={errors?.newPassword}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end">
                                                            <IconButton
                                                                size="small"
                                                                aria-label={showNewPassword ? 'hide the password' : 'display the password'}
                                                                onClick={() => setShowNewPassword(!showNewPassword)}
                                                                edge="end"
                                                            >
                                                                {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item md={12}>
                                                <TextField
                                                    autoComplete={false}
                                                    inputRef={confirmPasswordInputRef}
                                                    label={<>Confirm Password <Required /></>}
                                                    fullWidth
                                                    size="small"
                                                    name='confirmPassword'
                                                    type={!showConfirmPassword ? 'password' : 'text'}
                                                    onChange={validateOnchange}
                                                    error={errors?.confirmPassword}
                                                    helperText={errors?.confirmPassword}
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end">
                                                            <IconButton
                                                                size="small"
                                                                aria-label={showConfirmPassword ? 'hide the password' : 'display the password'}
                                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                                edge="end"
                                                            >
                                                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleChangePassword}
                                                size="small"
                                                color="primary"
                                                disabled={isPending || Object.keys(removeEmptyKeys(errors))?.length > 0}
                                            >
                                                {isPending ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <CircularProgress size={'20px'} color='inherit' />
                                                    Loading...
                                                </div>
                                                    : 'Submit'
                                                }
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={onClose}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                            >
                                                Close
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    isPending: state.changePassword.isChangePasswordPending,
    errorMessage: state.changePassword.changePasswordErrorMessage,
    isSuccess: state.changePassword.isSuccess,
})
const mapDispatchToProps = (dispatch) => ({
    changePassword: (formData) => dispatch(changePassword(formData)),
    changePasswordErrorClear: () => dispatch(changePasswordErrorClear()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);